const northEastItinerary = {
  slug:"north-east-explorer",
  title: "North East Explorer",
  duration: "7 days",
  location: "Meghalaya & Assam, India",
  difficulty: "Moderate",
  priceRange: "$$ (Mid-range)",
  bestTime: "October to April",
  description:
    "Discover waterfalls, hills, caves, and unique tribal culture in India’s scenic North East.",

  highlights: [
    "Living root bridges",
    "Waterfalls of Cherrapunji",
    "Umiam Lake",
    "Kaziranga National Park"
  ],
highlight360Views: [
  { label: "Shillong", place: "Shillong, Meghalaya" },
  { label: "Cherrapunji", place: "Cherrapunji, Meghalaya" },
  { label: "Kaziranga", place: "Kaziranga National Park, Assam" },
  { label: "Tawang Monastery", place: "Tawang Monastery, Arunachal Pradesh" },
  { label: "Ziro Valley", place: "Ziro Valley, Arunachal Pradesh" }
],

  image:
    "https://images.unsplash.com/photo-1600508774634-4e11d34730e2",

  days: [
    {
      day: 1,
      title: "Arrival in Guwahati",
      places: [
        "Lokpriya Gopinath Bordoloi International Airport",
        "Guwahati City",
        "Kamakhya Temple",
        "Brahmaputra River",
        "Umananda Island"
      ],
      activities: [
        "Arrival and hotel check-in",
        "Visit Kamakhya Temple"
      ],
      accommodation: "Guwahati hotel",
      meals: "Dinner included"
    },
    {
      day: 2,
      title: "Shillong & Umiam Lake",
      places: [
        "Shillong",
        "Umiam Lake",
        "Ward's Lake",
        "Shillong Peak",
        "Elephant Falls"
      ],
      activities: [
        "Drive to Shillong",
        "Visit Umiam Lake",
        "Local sightseeing"
      ],
      accommodation: "Shillong hotel",
      meals: "Breakfast included"
    },
    {
      day: 3,
      title: "Cherrapunji",
      places: [
        "Cherrapunji",
        "Nohkalikai Falls",
        "Seven Sisters Falls",
        "Mawsmai Cave",
        "Eco Park Cherrapunji",
        "Dainthlen Falls"
      ],
      activities: [
        "Visit Nohkalikai Falls",
        "Mawsmai Cave",
        "Seven Sisters Falls"
      ],
      accommodation: "Cherrapunji hotel",
      meals: "Breakfast included"
    },
    {
      day: 4,
      title: "Living Root Bridge Trek",
      places: [
        "Tyrna Village",
        "Nongriat Village",
        "Double Decker Living Root Bridge",
        "Rainbow Falls"
      ],
      activities: [
        "Trek to Double Decker Root Bridge",
        "Village exploration"
      ],
      accommodation: "Shillong hotel",
      meals: "Breakfast included"
    },
    {
      day: 5,
      title: "Kaziranga National Park",
      places: [
        "Kaziranga National Park",
        "Kaziranga Central Range",
        "Kaziranga Western Range"
      ],
      activities: [
        "Drive to Kaziranga",
        "Jeep safari"
      ],
      accommodation: "Kaziranga lodge",
      meals: "Breakfast & dinner included"
    },
    {
      day: 6,
      title: "Safari & Return to Guwahati",
      places: [
        "Kaziranga National Park",
        "Brahmaputra River",
        "Guwahati City"
      ],
      activities: [
        "Morning safari",
        "Return to Guwahati"
      ],
      accommodation: "Guwahati hotel",
      meals: "Breakfast included"
    },
    {
      day: 7,
      title: "Departure",
      places: [
        "Fancy Bazaar, Guwahati",
        "Lokpriya Gopinath Bordoloi International Airport"
      ],
      activities: ["Departure"],
      accommodation: "N/A",
      meals: "Breakfast included"
    }
  ],

  inclusions: [
    "6 nights accommodation",
    "Daily breakfast",
    "Safari charges",
    "All transfers"
  ],

  exclusions: [
    "Flights",
    "Personal expenses",
    "Trekking gear"
  ],

  tips: [
    "Carry rain gear",
    "Comfortable trekking shoes",
    "Respect local culture"
  ],

  budget: {
    total: "₹30,000–40,000 per person"
  }
};

export default northEastItinerary;
